import Box from '@mui/material/Box'

/**
 * Marca PO27 / Transfere Auto.
 *
 * O selo usa `public/brand/po27-mark.svg`: o desenho do logo (P2 em cima, O7
 * embaixo) em verde sobre o bloco preto, como na aplicação oficial.
 *
 * O SVG é PROVISÓRIO — traçado a partir do único arquivo que o design
 * entregou até agora (um JPG de 200 px). Quando o SVG oficial chegar, basta
 * substituir o arquivo mantendo o nome e o recorte só das letras (sem o
 * quadrado preto, que vem do `bgcolor` daqui): nenhum código muda.
 */
export function Logo({ size = 32, withWordmark = true }: { size?: number; withWordmark?: boolean }) {
  return (
    <Box
      aria-label={withWordmark ? 'PO27 Transfere Auto' : 'PO27'}
      role="img"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        // `view-transition-name` deixa o logo ser o elemento compartilhado na
        // transição de rota do login para o dashboard (M5).
        viewTransitionName: 'logo',
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: size,
          height: size,
          borderRadius: 1,
          bgcolor: '#000000',
          display: 'grid',
          placeItems: 'center',
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src="/brand/po27-mark.svg"
          // Decorativo: o nome acessível está no contêiner externo.
          alt=""
          draggable={false}
          // As letras ocupam ~64% do lado do bloco, como no arquivo oficial
          // (letras ≈ 128 de 200 px).
          sx={{ width: '64%', height: 'auto', display: 'block' }}
        />
      </Box>

      {withWordmark && (
        <Box
          aria-hidden
          component="span"
          sx={{
            fontWeight: 600,
            letterSpacing: '0.02em',
            fontSize: size * 0.5,
            whiteSpace: 'nowrap',
          }}
        >
          Transfere Auto
        </Box>
      )}
    </Box>
  )
}
